import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Formik, FormikValues } from 'formik';
import * as yup from 'yup';
import { useSelector } from 'react-redux';

import { forcePayment } from 'actions/adminTool';
import Header from 'components/AppBar';
import SubmitButton from 'components/Buttons/SubmitButton';
import FormikSubmitErrorEffect from 'components/FormikSubmitErrorEffect';
import Input from 'components/Input';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import Section from 'components/Section';
import useToast from 'hooks/useToast';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { RootState } from 'store';

import { Container, Wrapper, FormContainer, Field } from './styles';

const AdminToolRetryApproval = () => {
  const history = useHistory();
  const { t } = useStoreTranslation();
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const accountResult = useSelector((state: RootState) => state.user.accountResult);

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading(true);

      const result = await forcePayment(
        values.travelItineraryId,
        accountResult?.companyId ?? '',
        accountResult?.sessionToken ?? '',
      );

      if (result.data.succeeded) {
        toast.add({ type: 'success', message: t('adminTool.retryApprovalForm.toastSuccess') });
      } else {
        const errorCode = result.data?.errors?.[0];
        let errorMsg: string;

        if (errorCode === 'ITINERARY_WITHOUT_PREVIOUS_PAYMENT') {
          errorMsg = t('adminTool.retryApprovalForm.errorWithoutPreviousPayment', { id: values.travelItineraryId });
        } else if (errorCode === 'ITINERARY_ACTION_REQUIRED') {
          errorMsg = t('adminTool.retryApprovalForm.errorActionRequired', { id: values.travelItineraryId });
        } else {
          errorMsg = errorCode ?? t('adminTool.retryApprovalForm.toastError');
        }

        toast.add({ type: 'danger', message: errorMsg });
      }
    } catch (error: any) {
      const responseData = error?.response?.data;
      const errorCode = responseData?.Errors?.[0] ?? responseData?.errors?.[0];
      let errorMessage: string;

      if (errorCode === 'ITINERARY_WITHOUT_PREVIOUS_PAYMENT') {
        errorMessage = t('adminTool.retryApprovalForm.errorWithoutPreviousPayment', { id: values.travelItineraryId });
      } else if (errorCode === 'ITINERARY_ACTION_REQUIRED') {
        errorMessage = t('adminTool.retryApprovalForm.errorActionRequired', { id: values.travelItineraryId });
      } else {
        errorMessage = t('adminTool.retryApprovalForm.toastError');
      }

      toast.add({ type: 'danger', message: errorMessage });
    }

    setIsLoading(false);
  };

  const validationSchema = yup.object().shape({
    travelItineraryId: yup.string().required(),
  });

  const initValues = {
    travelItineraryId: '',
  };

  return (
    <Wrapper className="target">
      <>
        <Mobile>
          <Header goBack={() => history.push('/corporate/adminTool')}>
            {t('adminTool.retryApprovalForm.title')}
          </Header>
        </Mobile>

        <Desktop>
          <ScreenHeader
            title={t('adminTool.retryApprovalForm.title')}
            subtitle={t('adminTool.retryApprovalForm.subtitle')}
          />
        </Desktop>

        <Container>
          <Formik
            initialStatus={{ rightCheckIfIsValid: true }}
            initialValues={initValues}
            validationSchema={validationSchema}
            onSubmit={(value) => handleSubmit(value)}
            isInitialValid={(formik: FormikValues) => validationSchema.isValidSync(formik.initialValues)}
          >
            {({ dirty, isSubmitting, isValid, values, setFieldValue }: FormikValues) => (
              <>
                <FormikSubmitErrorEffect />
                <FormContainer marginBottom={dirty}>
                  <Section title={t('adminTool.retryApprovalForm.parameters')} joinContent={true}>
                    <Field name="travelItineraryId" label={t('adminTool.retryApprovalForm.itineraryId')}>
                      <Input placeholder="" />
                    </Field>

                    <br />
                    <br />
                  </Section>
                  <SubmitButton dirty={true} isEdit loading={isLoading}>
                    {t('adminTool.retryApprovalForm.button')}
                  </SubmitButton>
                </FormContainer>
              </>
            )}
          </Formik>
        </Container>
      </>
    </Wrapper>
  );
};

export default AdminToolRetryApproval;
